export const financingColors = {
  FALABELLA: '#13CE66',
  AUTOFIN: '#6185DB',
  GLOBAL: '#7D67BC',
  EUROCAPITAL: '#FAD901',
  SANTANDER: '#FA5A7D',
  FULLMOTORS: '#F03738',
}
